/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInFilesize: core.serialization.ObjectSchema<serializers.NotInFilesize.Raw, Truvity.NotInFilesize> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.number()),
    });

export declare namespace NotInFilesize {
    export interface Raw {
        values: number[];
    }
}
